"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var escape = require("html-escape");
function StripHtml(stringWithHtml) {
    var plainText = stringWithHtml.replace(/<[^>]+>/g, " ").trim();
    plainText = plainText.replace("&nbsp;", " ");
    return plainText.replace(/[\s]{2,}/g, " ");
}
exports.StripHtml = StripHtml;
function EscapeHtmlString(string) {
    return escape(string);
}
exports.EscapeHtmlString = EscapeHtmlString;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/HtmlUtilities.ts
// module id = 810
// module chunks = 0